import About from "./components/About";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Program from "./components/Program";
import Venue from "./components/Venue";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Program />
      <Venue />
      <Footer />
    </div>
  );
}

export default App;
